import { useState, type ReactElement } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogActions,
  Button,
  Tab,
  Tabs
} from "@mui/material";
import Label from "src/components/label";
import Scrollbar from "src/components/scrollbar";
import { Transition } from "src/shorts/Transition";

export type ResultModalProps = {
  title?: string;
  succeed: any[];
  failed: any[];
  cols: string[];
  onClose: VoidFunction
};

export const RESULT_MODAL = 'RESULT_MODAL';

export const ResultModal = ({
  title,
  succeed,
  failed,
  cols,
  onClose,
}: ResultModalProps): ReactElement => {
  const [tab, setTab] = useState<string>(failed.length > 0 ? 'failed' : 'succeed');
  return (
    <Dialog
      open
      TransitionComponent={Transition}
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-slide-title">{title || 'Action result'}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Tabs
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
            value={tab}
            onChange={(_, value) => {
              setTab(value);
            }}
          >
            <Tab
              disableRipple
              value="succeed"
              icon={<Label color="success"> {succeed.length} </Label>}
              label="Succeed"
              disabled={succeed.length === 0}
            />
            <Tab
              disableRipple
              value="failed"
              icon={<Label color="error"> {failed.length} </Label>}
              label="Failed"
              disabled={failed.length === 0}
            />
          </Tabs>
          <Scrollbar sx={{ maxHeight: '200px', marginTop: 2, pb: 1, mb: 1 }}>
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    {cols.map((colName, index) => (
                      <TableCell key={index}>{colName}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tab === 'succeed' &&
                    succeed.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        {cols.map((colName, index) => (
                          <TableCell key={index}>{row[colName]}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  {tab === 'failed' &&
                    failed.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        {cols.map((colName, index) => (
                          <TableCell key={index}>{row[colName]}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
